import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import UserContext from './UserContext';
import useEventBus from "../../../eventBus/useEventBus";
import { signOut, getConsumerId, getIdToken, publishFetchProfileData } from './utils/userProviderUtils';
export default (function (_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoggedIn = _useState2[0],
    setIsLoggedIn = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    userInfo = _useState4[0],
    setUserInfo = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUserInfoReady = _useState6[0],
    setIsUserInfoReady = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    profileDataSuccessCompleted = _useState8[0],
    setProfileDataSuccessCompleted = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    errorFetchingData = _useState10[0],
    setErrorFetchingData = _useState10[1];
  useEventBus('userProfile.authData', function (_ref2) {
    var isLoggedIn = _ref2.isLoggedIn,
      email = _ref2.email,
      authProviderName = _ref2.authProviderName,
      authProviderCode = _ref2.authProviderCode,
      consumerId = _ref2.consumerId;
    setErrorFetchingData(false);
    setIsLoggedIn(isLoggedIn);
    setUserInfo({
      email: email,
      authProviderName: authProviderName,
      authProviderCode: authProviderCode,
      consumerId: consumerId
    });
    if (isLoggedIn) {
      publishFetchProfileData();
    }
    setIsUserInfoReady(true);
  });
  useEventBus('userProfile.profileDataSuccess', function (data) {
    setErrorFetchingData(false);
    setUserInfo(_objectSpread(_objectSpread({}, userInfo), data));
    setProfileDataSuccessCompleted(true);
  });
  useEventBus('auth.signout', function () {
    setErrorFetchingData(false);
    setIsLoggedIn(false);
    setUserInfo(null);
    setProfileDataSuccessCompleted(false);
  });
  useEventBus('userProfile.error', function () {
    setErrorFetchingData(true);
    setIsLoggedIn(false);
    setIsUserInfoReady(true);
  });
  return React.createElement(React.Fragment, null, React.createElement(UserContext.Provider, {
    value: {
      isLoggedIn: isLoggedIn,
      isUserInfoReady: isUserInfoReady,
      setIsLoggedin: setIsLoggedIn,
      signOut: signOut,
      userInfo: userInfo,
      getIdToken: getIdToken,
      getConsumerId: getConsumerId,
      setUserInfo: setUserInfo,
      errorFetchingData: errorFetchingData,
      profileDataSuccessCompleted: profileDataSuccessCompleted,
      setProfileDataSuccessCompleted: setProfileDataSuccessCompleted
    }
  }, children));
});